<template>
  <div id="sys-enum">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchObj">
        <el-form-item label="枚举类型">
          <el-select
            v-model="searchObj.main_key"
            placeholder="请选择或输入关键字筛选"
            clearable
            filterable
            :filter-method="filterTypeOption"
            style="min-width: 280px;"
          >
            <el-option
              v-for="item in filteredTypeOptions"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="pageChange(1)">
            查询
          </el-button>
          <el-button size="small" type="success" icon="el-icon-plus" @click="openEdit()">
            新增枚举
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-wrap">
      <el-table
        size="small"
        :data="list"
        :default-sort="{ prop: 'id', order: 'descending' }"
        @sort-change="handleSortChange"
      >
        <el-table-column prop="id" label="ID" width="90" sortable="custom" />
        <el-table-column prop="main_key" label="main_key" width="220" />
        <el-table-column prop="enum_key" label="enum_key" width="180" />
        <el-table-column prop="enum_value" label="枚举值" />
        <el-table-column label="配图" width="72">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.pic"
              :src="scope.row.pic"
              fit="cover"
              style="width: 44px; height: 44px; border-radius: 4px;"
              :preview-src-list="[scope.row.pic]"
            />
            <span v-else class="gray9">-</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="80" />
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag size="small" :type="scope.row.status === 1 ? 'success' : 'info'">
              {{ scope.row.status === 1 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" />
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEdit(scope.row)">编辑</el-button>
            <el-button
              type="text"
              size="small"
              @click="changeStatus(scope.row, scope.row.status === 1 ? 0 : 1)"
            >
              {{ scope.row.status === 1 ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination">
      <el-pagination
        @current-change="pageChange"
        background
        :current-page="searchObj.page"
        :page-size="searchObj.list_rows"
        layout="total, prev, pager, next, jumper"
        :total="total"
      />
    </div>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id ? '编辑枚举' : '新增枚举'" :visible.sync="visible" width="520px">
      <el-form :model="form" label-width="90px" size="small">
        <el-form-item label="枚举类型" v-if="!form.id">
          <el-select
            v-model="form.main_key"
            placeholder="请选择或输入关键字筛选"
            filterable
            :filter-method="filterTypeOption"
            style="width: 100%;"
          >
            <el-option
              v-for="item in filteredTypeOptions"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="enum_key">
          <el-input v-model="form.enum_key" placeholder="唯一英文key" />
        </el-form-item>
        <el-form-item label="枚举值">
          <el-input v-model="form.enum_value" placeholder="展示文本" />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.sort" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" />
        </el-form-item>
        <el-form-item label="配图（可选）">
          <div class="pic-row">
            <el-button size="small" icon="el-icon-picture-outline" @click="openUpload">上传图片</el-button>
            <el-image
              v-if="form.pic"
              :src="form.pic"
              fit="cover"
              class="pic-preview"
              :preview-src-list="[form.pic]"
            />
          </div>
          <el-input
            v-model="form.pic"
            class="pic-url-input"
            placeholder="上传后自动填入地址，也可手动输入图片 URL"
            clearable
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="loading" @click="submitSave">确定</el-button>
      </div>
    </el-dialog>

    <Upload v-if="isupload" :config="{ file_type: 'image', total: 1 }" @returnImgs="onUploadPic" />
  </div>
</template>

<script>
import request from '@/utils/request'
import Upload from '@/components/file/Upload.vue'

export default {
  name: 'SysEnumSetting',
  components: { Upload },
  data () {
    return {
      searchObj: {
        page: 1,
        list_rows: 15,
        main_key: '',
        sort_field: 'id',
        sort_order: 'desc'
      },
      list: [],
      total: 0,
      typeList: {},
      /** 枚举类型下拉（filter-method 驱动） */
      filteredTypeOptions: [],
      visible: false,
      loading: false,
      isupload: false,
      form: {
        id: null,
        main_key: '',
        enum_key: '',
        enum_value: '',
        pic: '',
        sort: 0,
        status: 1,
        remark: ''
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      request._get('shop/setting.sysenum/index', this.searchObj).then(res => {
        const { list, typeList } = res.data
        this.list = list.data
        this.total = list.total
        this.typeList = typeList || {}
        this.filterTypeOption('')
      })
    },
    /** 枚举类型下拉模糊：匹配 main_key、中文名、组合展示文案 */
    filterTypeOption (query) {
      const q = (query || '').trim().toLowerCase()
      const all = Object.keys(this.typeList).map(key => ({
        key,
        label: `${this.typeList[key]}（${key}）`
      }))
      if (!q) {
        this.filteredTypeOptions = all
        return
      }
      this.filteredTypeOptions = all.filter(item => {
        const name = String(this.typeList[item.key] || '')
        return (
          item.key.toLowerCase().includes(q) ||
          name.toLowerCase().includes(q) ||
          item.label.toLowerCase().includes(q)
        )
      })
    },
    handleSortChange ({ prop, order }) {
      if (prop !== 'id') return
      if (order === 'ascending') {
        this.searchObj.sort_field = 'id'
        this.searchObj.sort_order = 'asc'
      } else if (order === 'descending') {
        this.searchObj.sort_field = 'id'
        this.searchObj.sort_order = 'desc'
      } else {
        this.searchObj.sort_field = ''
        this.searchObj.sort_order = ''
      }
      this.pageChange(1)
    },
    pageChange (page) {
      this.searchObj.page = page
      this.getData()
    },
    openEdit (row) {
      if (row) {
        this.form = {
          id: row.id,
          main_key: row.main_key,
          enum_key: row.enum_key,
          enum_value: row.enum_value,
          pic: row.pic || '',
          sort: row.sort,
          status: row.status,
          remark: row.remark
        }
      } else {
        this.form = {
          id: null,
          main_key: this.searchObj.main_key || '',
          enum_key: '',
          enum_value: '',
          pic: '',
          sort: 0,
          status: 1,
          remark: ''
        }
      }
      this.visible = true
    },
    submitSave () {
      if (!this.form.enum_key || !this.form.enum_value) {
        this.$message.error('enum_key 和 枚举值 不能为空')
        return
      }
      if (!this.form.id && !this.form.main_key) {
        this.$message.error('请选择枚举类型')
        return
      }
      this.loading = true
      const api = this.form.id ? 'shop/setting.sysenum/edit' : 'shop/setting.sysenum/add'
      request._post(api, this.form).then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.getData()
      }).finally(() => {
        this.loading = false
      })
    },
    changeStatus (row, status) {
      request._post('shop/setting.sysenum/changeStatus', { id: row.id, status }).then(() => {
        this.$message.success('操作成功')
        this.getData()
      })
    },
    openUpload () {
      this.isupload = true
    },
    onUploadPic (imgs) {
      this.isupload = false
      if (imgs && imgs.length && imgs[0].file_path) {
        this.form.pic = imgs[0].file_path
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wrap {
  margin-top: 10px;
}
.pagination {
  margin-top: 15px;
  text-align: right;
}
.gray9 {
  color: #999;
  font-size: 12px;
}
.pic-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.pic-preview {
  width: 72px;
  height: 72px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
}
.pic-url-input {
  max-width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/setting/sysenum/index.vue